import ArtifactGroupType from "../base/ArtifactGroupType";


const BronzeDromedaryStatue = {
  id: '152',
  name: 'Bronze Dromedary Statue',
  groupIcon: 'PathsOfIncense',
  type: ArtifactGroupType.PATH_OF_INCENSE,
  icon: 'BronzeDromedaryStatue',
  power: 10,
  gameId: 'BronzeDromedaryStatue'
};

export default BronzeDromedaryStatue;
